// extracted by mini-css-extract-plugin
module.exports = {"header":"CreditReports_header__x994Q"};